import { render } from "./OnboardingPrompt.vue?vue&type=template&id=ec9aff40&scoped=true"
import script from "./OnboardingPrompt.vue?vue&type=script&lang=js"
export * from "./OnboardingPrompt.vue?vue&type=script&lang=js"

import "./OnboardingPrompt.vue?vue&type=style&index=0&id=ec9aff40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec9aff40"]])

export default __exports__